export function copyCommonProperties(source, target) {
    var common = _.intersection(_.keys(source), _.keys(target));
    common.forEach(c => target[c] = source[c]);
}

export function csvToArray(properties) {
    if (properties && _.isString(properties)) {
        return properties.split(",").map(_.trim);
    }
    return properties;
}

export function resetStoreStateProperties(state) {
    Object.keys(state).forEach(p => state[p] = null);
}

export function fieldsToSummary(store, fields, optEmptyText) {
    let str = '';
    let fieldsArr = Array.isArray(fields) ? fields : fields.split(',');

    for(let i = 0; i < fieldsArr.length; i++){
        if (store[fieldsArr[i]]) {
            str = str ? str + ', ' + store[fieldsArr[i]] : store[fieldsArr[i]];
        }
    }
    return str ? str : optEmptyText || 'None';
}

export function toCamelCase(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
      return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
    }).replace(/\s+/g, '');
  }

export function removeSpecialCharacters(str) {
    return _.chain(str.split(""))
        .map(char => (/^[a-z0-9\s]$/i.test(char)) ? char : null)
        .compact()
        .value()
        .join("");
  }

export function createSelectOptions(values){
    return values.map(v => Object.assign({id:v, name:v, value:v}));
}

export function getSelectValueNameById(values, id){
    let optionName = values.find(v => v.id == id);
    return optionName ? optionName.name : "";
}

export function getVueTablesOptions() {
    return {
      sortIcon: {
      base : 'fa',
      is: 'fa-sort',
      up: 'fa-sort-asc',
      down: 'fa-sort-desc'
    },
    skin: "table table-bordered table-condensed",
  };
}

export function truncateString(str, num) {
    return str.length > num ?  str.slice(0, num) + '...' : str;
}

export function isValidDate(str) {
    var d = moment(str, 'MM/DD/YYYY', true);
    if(!d.isValid()) return false;
    return d.isBefore("9999-12-31") && d.isAfter("1753-01-01");
}

export async function ignoreOnHighlight(callback) {
  setTimeout(async () => {
    let selection = window.getSelection();
    if (selection && !!selection.toString()) return;

    await callback();
  }, 0);
}

export function arrayToPrettyCsv(array) {
  return _.compact(array).filter(x => x !== undefined && x !== null).map(x => x.trim()).join(', ');
}



// WEBPACK FOOTER //
// ./src/framework/utils/utils.js